import { 
  Texture, 
  Material, 
  Object3D, 
  sRGBEncoding, 
  Mesh 
} from 'three'
import { IEnvironmentHelper } from "./environment"
import { getOverloadedMaterial } from './materialsConfiguration'

interface IMaterialWithMap extends Material {
  map: Texture
  emissiveMap: Texture  
}

function isMaterialWithMap(m: Material | IMaterialWithMap ): m is IMaterialWithMap {
  return 'map' in m && 'emissiveMap' in m
}

interface IMeshStandartMaterial extends Material {
  envMap: Texture | null
}
function isMeshStandardMaterial(m: Material | IMeshStandartMaterial): m is IMeshStandartMaterial {
  return 'envMap' in m
}

const encoding = sRGBEncoding
export function updateAllMaterials(object: Object3D, environmentHelper: IEnvironmentHelper) {
  traverseMaterials(object, async (mesh, material, index) => {    
    updateMaterialValues(mesh, material, index)
    updateMaps(material)
    await updateMaterialEnvironment(material, environmentHelper)
  })
}

async function updateMaterialEnvironment(m: Material, environmentHelper: IEnvironmentHelper) {
  if (isMeshStandardMaterial(m)) {    
    m.envMap = (await environmentHelper.getEnvironmentForMaterial(m.name))?.map ?? null
  }
}

function updateMaps(m: Material) {
  if (isMaterialWithMap(m)){    
    if (m.map) m.map.encoding = encoding
    if (m.emissiveMap) m.emissiveMap.encoding = encoding
    if (m.map || m.emissiveMap) m.needsUpdate = true
  }
}

function updateMaterialValues(mesh: Mesh, material: Material, index: number) { 
  const updateMaterial = getOverloadedMaterial(mesh, material);
  if (updateMaterial){
    if(Array.isArray(mesh.material))
      mesh.material[index] = updateMaterial
    else
      mesh.material = updateMaterial
  }
}

function traverseMaterials(object: Object3D, callback: (mesh: Mesh, material: Material, index: number) => Promise<void>) {
  object.traverse(async (node) => {
    const mesh = node as Mesh
    if (mesh && mesh.material) {
      const materials = Array.isArray(mesh.material) ? mesh.material : [mesh.material]
      for (let index = 0; index < materials.length; index++) {
        const mat = materials[index];
        await callback(mesh, mat, index)
      }      
    }
  })
}
